/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardOccurrence from './tumor-board-occurrence';
import TumorBoardOccurrenceDetail from './tumor-board-occurrence-detail';
import TumorBoardOccurrenceUpdate from './tumor-board-occurrence-update';
import TumorBoardOccurrenceDeleteDialog from './tumor-board-occurrence-delete-dialog';

const TumorBoardOccurrenceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardOccurrence />} />
    <Route path="new" element={<TumorBoardOccurrenceUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardOccurrenceDetail />} />
      <Route path="edit" element={<TumorBoardOccurrenceUpdate />} />
      <Route path="delete" element={<TumorBoardOccurrenceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardOccurrenceRoutes;
